import {
  Apple,
  BatteryMedium,
  Cross,
  Droplets,
  Fuel,
  Nut,
  PackageOpen,
} from "lucide-react";

import { formatQuantity } from "../lib/format";
import type { Catalog, GameState, ResourceKey } from "../types";

const icons = {
  food: Apple,
  water: Droplets,
  medicine: Cross,
  fuel: Fuel,
  ammunition: PackageOpen,
  scrap: Nut,
  components: BatteryMedium,
} satisfies Record<ResourceKey, typeof Apple>;

export function ResourceBar({ state, catalog }: { state: GameState; catalog: Catalog }) {
  return (
    <div className="resource-bar" aria-label="Bunker resources">
      {(Object.keys(catalog.resources) as ResourceKey[]).map((key) => {
        const definition = catalog.resources[key];
        const Icon = icons[key];
        const percent = (state.resources[key] / state.resource_capacity[key]) * 100;
        const overflow = state.resource_overflow?.[key]
          ?? Math.max(0, state.resources[key] - state.resource_capacity[key]);
        return (
          <div
            className={`resource resource-${definition.tone} ${overflow > 0 ? "resource-overflowing" : ""}`}
            key={key}
            title={`${definition.name}: ${formatQuantity(state.resources[key], catalog.quantity_scale)} / ${formatQuantity(state.resource_capacity[key], catalog.quantity_scale)} ${definition.unit}${overflow > 0 ? `; ${formatQuantity(overflow, catalog.quantity_scale)} over safe capacity` : ""}`}
          >
            <Icon size={15} aria-hidden="true" />
            <span className="resource-name">{definition.name}</span>
            <strong>{formatQuantity(state.resources[key], catalog.quantity_scale)}</strong>
            {overflow > 0 && <em aria-label={`${definition.name} exceeds safe capacity`}>over</em>}
            <i><b style={{ width: `${Math.min(100, percent)}%` }} /></i>
          </div>
        );
      })}
    </div>
  );
}
